(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1486],{

/***/ 35169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plate/[username]/[pageSlug]",
      function () {
        return __webpack_require__(74458);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ StyledForm; },
/* harmony export */   "H2": function() { return /* binding */ H2; }
/* harmony export */ });
/* unused harmony export H3 */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-family: "IBM Plex Mono", monospace;\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 10px;\n  color: ",
        ';\n  font-family: "IBM Plex Mono", monospace;\n  font-weight: 500;\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "IBM Plex Mono", monospace;\n  font-size: "24px";\n  font-weight: 600;\n  color: ',
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-14d23675-0"
})(_templateObject());
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-14d23675-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-14d23675-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});


/***/ }),

/***/ 74458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _pageSlug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(61253);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ./src/classes/plate/Plate.ts + 13 modules
var Plate = __webpack_require__(75696);
// EXTERNAL MODULE: ./src/components/Layout/LoadingWrapper.tsx + 2 modules
var LoadingWrapper = __webpack_require__(26080);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(37296);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(40974);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(86524);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ../../packages/common/dist/index.js
var dist = __webpack_require__(45869);
// EXTERNAL MODULE: ./src/components/UI/Modal/Modal.tsx
var Modal = __webpack_require__(8505);
// EXTERNAL MODULE: ./src/app/globalStyles.ts
var globalStyles = __webpack_require__(458);
// EXTERNAL MODULE: ./src/components/DrilledView/DrilledView.tsx + 10 modules
var DrilledView = __webpack_require__(41358);
// EXTERNAL MODULE: ./src/components/Layout/PageLayout.tsx
var PageLayout = __webpack_require__(18057);
// EXTERNAL MODULE: ./src/classes/utilities/PositionUtils.ts
var PositionUtils = __webpack_require__(48674);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(29725);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(7599);
// EXTERNAL MODULE: ./src/classes/block/block-types/index.ts + 10 modules
var block_types = __webpack_require__(20265);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(30440);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/CodeBlock/lib/LanguageOption.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "IBM Plex Mono";\n  padding: 5px;\n  color: #aeaeae;\n  font-size: 12px;\n  background-color: ',
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function LanguageOption(param) {
    var language = param.language, changeLanguage = param.changeLanguage, selectedIndex = param.selectedIndex, setSelectedIndex = param.setSelectedIndex, index = param.index;
    // option ref
    var optionRef = (0,react.useRef)(null);
    // scroll to option if selected
    (0,react.useEffect)(function() {
        if (selectedIndex === index) {
            var optionElement = optionRef.current;
            if (optionElement) {
                optionElement.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest"
                });
            }
        }
    }, [
        selectedIndex,
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguageOption, {
        ref: optionRef,
        onClick: function() {
            return changeLanguage(language);
        },
        $isSelected: index === selectedIndex,
        onMouseEnter: function() {
            return setSelectedIndex(index);
        },
        onMouseLeave: function() {
            return setSelectedIndex(null);
        },
        children: language
    }, language);
};
var StyledLanguageOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e887316-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $isSelected = param.$isSelected;
    return $isSelected && theme.subtleContrast;
});

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/CodeBlock/lib/LanguageMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function LanguageMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-color: ",
        ";\n  top: ",
        ";\n  left: 0;\n  border: ",
        ";\n  max-height: 180px;\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    width: 5px;\n  }\n"
    ]);
    LanguageMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function LanguageMenu(param) {
    var block = param.block, closeMenu = param.closeMenu;
    var blockHeight = block.observe(function(state) {
        return state.height;
    });
    var selectedLanguage = block.observe(function(state) {
        return state.language;
    });
    var ref = (0,react.useState)(block_types/* CodeBlock.supportedLanguages.findIndex */.dn.supportedLanguages.findIndex(function(lang) {
        return lang === selectedLanguage;
    })), selectedIndex = ref[0], setSelectedIndex = ref[1];
    (0,react.useEffect)(function() {
        // adds a keydown event listener to capture arrow keys
        document.addEventListener("keydown", handleKeydown, false);
        return function() {
            // remove event listener when block unmounts
            document.removeEventListener("keydown", handleKeydown, false);
        };
    }, [
        selectedIndex
    ]);
    // when an option is clicked or enter is pressed
    var changeLanguage = function(language) {
        block.changeLanguage(language);
        closeMenu();
    };
    var handleKeydown = function(e) {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            e.stopPropagation();
            // if there is a next option, increment selected
            setSelectedIndex(Math.min((selectedIndex || 0) + 1, block_types/* CodeBlock.supportedLanguages.length */.dn.supportedLanguages.length - 1));
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            e.stopPropagation();
            // if there is a previous option, decrement selected
            setSelectedIndex(Math.max((selectedIndex || 0) - 1, 0));
        }
        if (e.key === "Enter") {
            e.preventDefault();
            if (selectedIndex === null) return;
            var newLanguage = block_types/* CodeBlock.supportedLanguages */.dn.supportedLanguages[selectedIndex];
            changeLanguage(newLanguage);
        }
        if (e.key === "Escape") {
            closeMenu();
            e.stopPropagation();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguageMenu, {
        blockHeight: blockHeight,
        id: constants/* CODE_LANG_MENU_ID */.$A,
        children: block_types/* CodeBlock.supportedLanguages.map */.dn.supportedLanguages.map(function(language, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageOption, {
                language: language,
                changeLanguage: changeLanguage,
                selectedIndex: selectedIndex,
                setSelectedIndex: setSelectedIndex,
                index: index
            }, language);
        })
    });
};
var StyledLanguageMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbfaf207-0"
})(LanguageMenu_templateObject(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var blockHeight = param.blockHeight;
    return "".concat(blockHeight, "px");
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.subtleContrast);
});

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/CodeBlock/styles.ts
var styles = __webpack_require__(8643);
// EXTERNAL MODULE: ./src/components/Hotkeys/hotkeys.ts
var hotkeys = __webpack_require__(63546);
// EXTERNAL MODULE: ./src/components/UI/NoSSR/NoSSR.tsx
var NoSSR = __webpack_require__(7615);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/CodeBlock/CodeBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 







// TODO: replace with a high quality package
var CodeEditor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3724).then(__webpack_require__.bind(__webpack_require__, 23724)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23724)
            ];
        }
    },
    ssr: false
});
var CodeBlockContent = function(param) {
    var block = param.block, editable = param.editable;
    var languageMenuRef = (0,react.useRef)(null);
    var codeBlockRef = (0,react.useRef)(null);
    var language = block.observe(function(state) {
        return state.language;
    });
    var ref = (0,react.useState)(false), dropDownOpen = ref[0], setDropDownOpen = ref[1];
    (0,esm/* useOnClickOutside */.t$)(languageMenuRef, function() {
        return editable && setDropDownOpen(false);
    });
    var handleKeyDown = function(e) {
        switch(e.code){
            case hotkeys/* KeyCodes.ESCAPE */.mW.ESCAPE:
                e.stopPropagation();
                break;
            case hotkeys/* KeyCodes.ARROW_LEFT */.mW.ARROW_LEFT:
            case hotkeys/* KeyCodes.ARROW_RIGHT */.mW.ARROW_RIGHT:
            case hotkeys/* KeyCodes.ARROW_UP */.mW.ARROW_UP:
            case hotkeys/* KeyCodes.ARROW_DOWN */.mW.ARROW_DOWN:
            case hotkeys/* KeyCodes.BACKSPACE */.mW.BACKSPACE:
                e.stopPropagation();
                break;
            default:
                // keep default behavior for hot keys
                if (e.metaKey) e.stopPropagation();
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* NoSSR */.r, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledCodeBlockContent */.ur, {
            ref: codeBlockRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeEditor, {
                    className: "CodeEditor",
                    id: block.codeEitorId,
                    value: block.snapshot.plainText,
                    onChange: function(e) {
                        return block.updatePlaintext(e.target.value);
                    },
                    onKeyDown: handleKeyDown,
                    placeholder: "Enter some code",
                    language: language,
                    padding: 25,
                    readOnly: !editable,
                    style: styles/* codeEditorStyles */.Pe
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: languageMenuRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledLanguage */.jr, {
                            onClick: function() {
                                return editable && setDropDownOpen(!dropDownOpen);
                            },
                            style: {
                                cursor: !editable ? "default" : "pointer"
                            },
                            children: language
                        }),
                        dropDownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageMenu, {
                            block: block,
                            closeMenu: function() {
                                return setDropDownOpen(false);
                            }
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/CodeBlock/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/ColorBlock/styles.ts
var ColorBlock_styles = __webpack_require__(89140);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ColorBlock/ColorBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function ColorBlockContent(param) {
    var block = param.block, plate = param.plate, editable = param.editable;
    var selection = plate.observe(function(state) {
        return state.selection;
    });
    var isSelected = selection.includes(block.snapshot.id);
    var color = block.observe(function(state) {
        return state.hex;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBlock_styles/* StyledColorBlockContent */.m, {
        onMouseDown: function(e) {
            // Prevent block from being unselected when clicking on color picker
            if (isSelected) {
                e.stopPropagation();
            }
        },
        color: color,
        children: isSelected && editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBlock_styles/* ColorPicker */.z, {
            type: "color",
            onChange: function(e) {
                return block.changeColor(e.target.value);
            },
            value: color
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ColorBlock/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/EmbeddedPlate/lib/styles.ts
var lib_styles = __webpack_require__(66772);
// EXTERNAL MODULE: ./src/components/Block/Placeholders/MessageBlock.tsx
var MessageBlock = __webpack_require__(67864);
// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/index.ts
var PageThumbnail = __webpack_require__(12539);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/EmbeddedPlate/EmbeddedPlate.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function EmbeddedPlate(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_styles/* EmbeddedPlateBlockContent */._7, {
        children: !block.embeddedPlate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBlock/* MessageBlock */.t, {
            children: "Plate deleted or made private."
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_styles/* PageBlockWrapper */.OO, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_styles/* PageBlockMaxWidth */.gP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageThumbnail/* PageThumbnail */.G, {
                    plate: block.embeddedPlate,
                    disableContextMenu: true
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/EmbeddedPlate/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/StandardFilePreview.tsx
var StandardFilePreview = __webpack_require__(16769);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/styles.ts
var FileBlock_styles = __webpack_require__(51993);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/Widgets/AudioWidget.tsx
var AudioWidget = __webpack_require__(48826);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/Widgets/VideoWidget.tsx
var VideoWidget = __webpack_require__(80342);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/PDFBlock/index.ts + 1 modules
var PDFBlock = __webpack_require__(63660);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/utility/FileStatusWrapper.tsx + 1 modules
var FileStatusWrapper = __webpack_require__(70967);
// EXTERNAL MODULE: ./src/components/Signup/SignupMethodButton.tsx
var SignupMethodButton = __webpack_require__(72423);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/FileBlock/FileBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 









function FileBlockContent(param) {
    var block = param.block, plate = param.plate;
    var isCurrentSession = plate.sessionManager.observe(function(state) {
        return state.isCurrentSession;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileBlock_styles/* StyledFileBlockContent */.Hr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileStatusWrapper/* FileStatusWrapper */.k, {
            block: block,
            children: function() {
                switch(block.fileType){
                    case block_types/* FileType.Audio */.Tv.Audio:
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileBlock_styles/* FileBlockWrapper */.e5, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupMethodButton/* IconWrapper */.a1, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* AudioIcon */.f4, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileBlock_styles/* FileName */.dJ, {
                                    children: [
                                        block.fileDisplayName,
                                        " ",
                                        "(".concat(block.readableFileSize, ")")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioWidget/* AudioWidget */.I, {
                                    block: block,
                                    disableMouse: isCurrentSession
                                })
                            ]
                        });
                    case block_types/* FileType.Video */.Tv.Video:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWidget/* VideoWidget */.a, {
                            block: block,
                            disableMouse: isCurrentSession
                        });
                    case block_types/* FileType.PDF */.Tv.PDF:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFBlock/* PDFBlock */.F, {
                            block: block,
                            disableMouse: isCurrentSession
                        });
                    case block_types/* FileType.Other */.Tv.Other:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardFilePreview/* StandardFilePreview */.C, {
                            block: block
                        });
                }
            }()
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/FileBlock/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/ImageBlock/styles.ts
var ImageBlock_styles = __webpack_require__(40026);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ImageBlock/ImagePicker.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function ImagePicker(param) {
    var block = param.block, editable = param.editable, plate = param.plate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageBlock_styles/* StyledImagePicker */.mS, {
                htmlFor: "file-upload-".concat(block.snapshot.id),
                className: "custom-file-upload",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Click to select an image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            fontSize: "11px",
                            paddingTop: "3px"
                        },
                        children: "(You can also drag and drop)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock_styles/* HiddenInput */.x1, {
                disabled: !editable,
                type: "file",
                accept: "image/*",
                multiple: false,
                onChange: function(e) {
                    return block.addFile(e.target.files[0], plate.dimensions);
                },
                id: "file-upload-".concat(block.snapshot.id)
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/ImageBlock/lib/Caption.tsx + 1 modules
var Caption = __webpack_require__(77545);
// EXTERNAL MODULE: ./src/components/Block/styles.ts
var Block_styles = __webpack_require__(49516);
// EXTERNAL MODULE: ./src/components/UI/Loading/Spinners/ScribeSpinner/ScribeSpinner.tsx
var ScribeSpinner = __webpack_require__(68922);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ImageBlock/ImageBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 








function ImageBlockContent(param) {
    var block = param.block, plate = param.plate, editable = param.editable;
    var imageFit = block.observe(function(state) {
        return state.imageFit;
    });
    var hasCaption = block.observe(function(state) {
        return state.hasCaption;
    });
    var ref = (0,react.useState)(true), imgLoading = ref[0], setImgLoading = ref[1];
    var ref1 = (0,react.useState)(false), imgHasErrored = ref1[0], setImgHasErroed = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageBlock_styles/* StyledImageBlockContent */.sR, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FileStatusWrapper/* FileStatusWrapper */.k, {
                block: block,
                fallbackComponent: editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePicker, {
                    block: block,
                    editable: editable,
                    plate: plate
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock_styles/* StyledImage */.Yo, {
                    onLoad: function() {
                        return setImgLoading(false);
                    },
                    onError: function() {
                        return setImgHasErroed(true);
                    },
                    alt: "block",
                    src: !imgHasErrored ? block.getImageLinkForSize("dynamic") : block.fallbackImageLink,
                    style: {
                        objectFit: imageFit,
                        display: imgLoading ? "none" : "block"
                    }
                })
            }),
            hasCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption/* Caption */.Y, {
                block: block,
                editable: editable
            }),
            imgLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_styles/* StyledLoadingMessage */.VX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScribeSpinner/* ScribeSpinner */.k, {})
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ImageBlock/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/LinkBlock/index.ts + 8 modules
var LinkBlock = __webpack_require__(28798);
// EXTERNAL MODULE: ../../node_modules/slate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(92144);
// EXTERNAL MODULE: ./src/classes/utilities/StringUtils.ts
var StringUtils = __webpack_require__(32536);
;// CONCATENATED MODULE: ./src/components/SlashMenu/slashMenuOptions.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


var SLASH_MENU_OPTIONS = [
    {
        name: "Text",
        blockType: dist.BlockType.Text,
        subtype: dist.TextType.Plain,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* TextBlockIcon */.U8, {}),
        description: "Write anything in plain text"
    },
    {
        name: "Heading 1",
        blockType: dist.BlockType.Text,
        subtype: dist.TextType.H1,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HeadingIcon */.bH, {}),
        description: "Add a large section heading"
    },
    {
        name: "Heading 2",
        blockType: dist.BlockType.Text,
        subtype: dist.TextType.H2,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HeadingIcon */.bH, {}),
        description: "Add a medium section heading"
    },
    {
        name: "Image",
        blockType: dist.BlockType.Image,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ImageBlockIcon */.Bh, {}),
        description: "Upload or embed an image"
    },
    {
        name: "Color",
        blockType: dist.BlockType.Color,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ColorBlockIcon */.Ag, {}),
        description: "Choose from millions of colors"
    },
    {
        name: "Mono",
        blockType: dist.BlockType.Text,
        subtype: dist.TextType.Mono,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* MonoBlockIcon */.ow, {}),
        description: "Write with monospace font"
    },
    {
        name: "Code",
        blockType: dist.BlockType.Code,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CodeBlockIcon */.MM, {}),
        description: "Insert a code block"
    },
    {
        name: "Quote",
        blockType: dist.BlockType.Text,
        subtype: dist.TextType.Quote,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* QuoteBlockIcon */.uj, {}),
        description: "Insert quote"
    }, 
];

// EXTERNAL MODULE: ./src/components/ViennaEditor/index.ts + 8 modules
var ViennaEditor = __webpack_require__(59422);
// EXTERNAL MODULE: ./src/components/ViennaEditor/lib/helpers.ts + 1 modules
var helpers = __webpack_require__(47306);
// EXTERNAL MODULE: ./src/components/ViennaEditor/lib/initialize.ts + 1 modules
var initialize = __webpack_require__(64304);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/TextBlock/styles.ts
var TextBlock_styles = __webpack_require__(33237);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/TextBlock/TextBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 











function TextBlockContent(param) {
    var block = param.block, editable = param.editable, plate = param.plate;
    var initialValue = (0,helpers/* getTextContent */.FB)(block.snapshot);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var blockRef = (0,react.useRef)(null);
    var selection = plate.observe(function(state) {
        return state.selection;
    });
    var isSelected = selection.includes(block.snapshot.id);
    var justCreated = Date.now() - new Date(block.snapshot.createdAt).getTime() < 2000;
    var autoFocus = editable && justCreated && isSelected;
    var textSubtype = block.observe(function(state) {
        return state.textType;
    });
    var ref = (0,react.useState)((0,initialize/* initializeViennaEditor */.y)()), editor = ref[0];
    var handleChange = function() {
        var isContentChange = editor.operations.some(function(op) {
            return op.type !== "set_selection";
        }); // check if the change is a content change
        if (isContentChange) {
            block.debouncedUpdateTextContent(editor.children);
        }
    };
    var handleSlashMenuOptionSelected = function(selectedOption) {
        var selectedType = selectedOption.blockType;
        var subtype = selectedOption.subtype;
        if (selectedType !== dist.BlockType.Text) {
            block.immediatelyUpdateTextContent(editor.children); // the "/" having been deleted, patch an update to the text content. needed only when changing the block type (in other cases, `handleChange` will be called)
            plate.repealAndReplaceTextBlock(block, selectedType);
        } else if (subtype) {
            block.changeTextType(subtype);
        }
    };
    /**
   * Creates an embed if you paste a url
   */ var handlePaste = function(e) {
        var isAlreadyTextInEditor = editor.children.map(function(n) {
            return index_es/* Node.string */.NB.string(n);
        }).join("\n");
        if (isAlreadyTextInEditor) return; // don't create an embed if there is already text in the editor
        var pastedText = e.clipboardData.getData("text/plain");
        if (block_types/* LinkBlock.shouldCreateEmbedFromPastedText */.rz.shouldCreateEmbedFromPastedText(pastedText)) {
            e.preventDefault();
            var textContent = StringUtils/* StringUtils.convertToSlateContent */.x.convertToSlateContent(pastedText);
            block.immediatelyUpdateTextContent(textContent); // immediately update text content (and plaintext) so the link block can pick it off as the URL
            plate.repealAndReplaceTextBlock(block, dist.BlockType.Link);
        }
    };
    var handleContextMenu = function(e) {
        // if block is selected (implying also editable), stop prop of right click, enabling spellcheck
        if (isSelected) {
            e.stopPropagation();
        }
    };
    //@critical wtf was this?
    // useEffect(() => {
    //   if (!editable && textContent.length) {
    //   editor.children = textContent;
    //   }
    // }, [textContent]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlock_styles/* StyledTextBlockContent */.c, {
        ref: blockRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViennaEditor/* ViennaEditor */.z, {
            editor: editor,
            initialValue: initialValue,
            handleChange: handleChange,
            readOnly: !editable,
            textSubtype: textSubtype,
            slashMenu: {
                options: SLASH_MENU_OPTIONS,
                onSelect: handleSlashMenuOptionSelected,
                positionRef: blockRef
            },
            editorId: block.textEditorId,
            autoFocus: autoFocus,
            onPaste: handlePaste,
            onContextMenu: handleContextMenu,
            wrapperStyles: block.getEditorStyles(theme)
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/TextBlock/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Block/Placeholders/ErrorBlock.tsx
var ErrorBlock = __webpack_require__(58369);
;// CONCATENATED MODULE: ./src/components/Block/BlockContent/BlockContent.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 









function BlockContent(param) {
    var block = param.block, plate = param.plate, editable = param.editable;
    var blockType = block.observe(function(state) {
        return state.type;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: function() {
            switch(blockType){
                case dist.BlockType.Text:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockContent, {
                        block: block,
                        editable: editable,
                        plate: plate
                    });
                case dist.BlockType.Image:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlockContent, {
                        block: block,
                        editable: editable,
                        plate: plate
                    });
                case dist.BlockType.Link:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkBlock/* LinkBlockContent */.f, {
                        block: block,
                        plate: plate
                    });
                case dist.BlockType.Color:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBlockContent, {
                        block: block,
                        editable: editable,
                        plate: plate
                    });
                case dist.BlockType.Code:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBlockContent, {
                        block: block,
                        editable: editable
                    });
                case dist.BlockType.File:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileBlockContent, {
                        block: block,
                        plate: plate
                    });
                case dist.BlockType.PlateWindow:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedPlate, {
                        block: block
                    });
                case dist.BlockType.BlockWindow:
                    var blockWindow = block;
                    return blockWindow.embeddedBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContent, {
                        block: blockWindow.embeddedBlock,
                        plate: plate,
                        editable: false
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* ErrorBlock */.i, {
                        children: "Connected block not found."
                    });
                default:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* ErrorBlock */.i, {
                        children: "Block type not found."
                    });
            }
        }()
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockContent/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Block/BlockTopbar/BlockTopbarButtons/index.ts + 3 modules
var BlockTopbarButtons = __webpack_require__(38500);
;// CONCATENATED MODULE: ./src/components/Block/BlockTopbar/BlockTopbarButtons/DeleteButton.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function DeleteButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background-color: transparent;\n  transition: background-color 0.3s ease;\n  &:hover {\n    background-color: ",
        ";\n  }\n  &:active {\n    background-color: ",
        ";\n  }\n  @media print {\n    display: none;\n  }\n"
    ]);
    DeleteButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var DeleteButton = function(param) {
    var deleteBlock = param.deleteBlock;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteButtonWrapper, {
        onMouseDown: function(e) {
            return e.stopPropagation();
        },
        onClick: deleteBlock,
        id: "cy-block-delete-button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* DeleteBlock */.br, {})
    });
};
var DeleteButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b49acd5-0"
})(DeleteButton_templateObject(), function(param) {
    var theme = param.theme;
    return theme.button.hover;
}, function(param) {
    var theme = param.theme;
    return theme.button.active;
});

// EXTERNAL MODULE: ./src/components/Block/BlockTopbar/styles.ts
var BlockTopbar_styles = __webpack_require__(78650);
// EXTERNAL MODULE: ./src/lib/utils/color.ts
var color = __webpack_require__(86085);
;// CONCATENATED MODULE: ./src/components/Block/BlockTopbar/PlateBlockTopbar.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PlateBlockTopbar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: "IBM Plex Mono";\n  font-size: 11px;\n  color: ',
        ";\n"
    ]);
    PlateBlockTopbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function PlateBlockTopbar(param) {
    var block = param.block, plate = param.plate, hovering = param.hovering;
    var ref;
    var editable = plate.observe(function(state) {
        return state.editable;
    });
    /* ------------------ Is Block Selected ------------------ */ var selection = plate.observe(function(state) {
        return state.selection;
    });
    var isSelected = selection.includes(block.snapshot.id);
    /* ------------------ Is Block Locked ------------------ */ var lockedBlocks = plate.socket.observe(function(state) {
        return state.lockedBlocks;
    });
    var isLocked = lockedBlocks.map(function(param) {
        var id = param.blockId;
        return id;
    }).includes(block.snapshot.id);
    var lockingUser = (ref = lockedBlocks.find(function(param) {
        var blockId = param.blockId;
        return blockId === block.snapshot.id;
    })) === null || ref === void 0 ? void 0 : ref.lockedBy;
    var tintColor = lockingUser ? (0,color/* stringToHSL */.J)(lockingUser, {
        lit: [
            40,
            90
        ],
        sat: [
            75,
            100
        ]
    }) : undefined;
    /* ------------------ For Button UI State ------------------ */ var isCurrentSession = plate.sessionManager.observe(function(state) {
        return state.isCurrentSession;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockTopbar_styles/* StyledBlockTopbar */.b, {
        isSelected: isSelected,
        tintColor: tintColor,
        isSelectable: editable && !isLocked,
        children: [
            lockingUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LockingUsername, {
                children: [
                    "@",
                    lockingUser
                ]
            }),
            editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteButton, {
                deleteBlock: function() {
                    return plate.deleteBlock(block.snapshot.id);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockTopbar_styles/* EmptySpace */.z, {
                onMouseDown: function(e) {
                    return editable && plate.onDragBlockStart(block, e);
                },
                editable: !isLocked && editable
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockTopbarButtons/* BlockTopbarButtons */.$, {
                block: block,
                hovering: hovering,
                isCurrentSession: isCurrentSession
            })
        ]
    });
}
var LockingUsername = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b49c09a1-0"
})(PlateBlockTopbar_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
});

// EXTERNAL MODULE: ./src/components/UI/ContextMenu/index.ts + 6 modules
var ContextMenu = __webpack_require__(79868);
;// CONCATENATED MODULE: ./src/components/Block/PlateBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PlateBlock_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 12px;\n  width: 12px;\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  cursor: se-resize;\n  &:active {\n    cursor: se-resize;\n  }\n"
    ]);
    PlateBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 8px;\n  width: 9px;\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  background: ",
        ";\n  opacity: 80%;\n  border-left: ",
        ";\n  border-top: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var PlateBlock = function(param) {
    var block = param.block, plate = param.plate;
    var blockRef = (0,react.useRef)(null);
    var editable = plate.observe(function(state) {
        return state.editable;
    });
    var selection = plate.observe(function(state) {
        return state.selection;
    });
    var isSelected = selection.includes(block.snapshot.id);
    var lockedBlocks = plate.socket.observe(function(state) {
        return state.lockedBlocks;
    });
    var isLocked = lockedBlocks.map(function(param) {
        var id = param.blockId;
        return id;
    }).includes(block.snapshot.id);
    var isScreenshotter = (0,es/* useSelector */.v9)(function(state) {
        return state.globalUI.uiSettings.isScreenshotter;
    });
    var ref = (0,react.useState)(false), hovering = ref[0], setHovering = ref[1];
    var zIndex = block.observe(function(state) {
        return state.zIndex;
    });
    var top = block.observe(function(state) {
        return state.top;
    });
    var left = block.observe(function(state) {
        return state.left;
    });
    var width = block.observe(function(state) {
        return state.width;
    });
    var height = block.observe(function(state) {
        return state.height;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenu/* ContextMenu */.x, {
        block: block,
        editable: editable,
        plate: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block_styles/* BlockContentContainer */.oy, {
            ref: blockRef,
            isScreenshotter: isScreenshotter,
            isSelected: isSelected,
            editable: editable && !isLocked,
            boxShadow: false,
            onMouseDown: function(e) {
                return editable && plate.onMouseDownBlock(block, e);
            },
            onMouseUp: function() {
                return plate.onMouseUpBlock(block);
            },
            onMouseEnter: function() {
                setHovering(true);
            },
            onMouseLeave: function() {
                return setHovering(false);
            },
            style: {
                top: PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(top),
                left: PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(left),
                width: PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(width) + 1,
                height: PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(height) + 1,
                zIndex: zIndex
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateBlockTopbar, {
                    plate: plate,
                    block: block,
                    hovering: hovering
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContent, {
                    block: block,
                    editable: editable && !isLocked,
                    plate: plate
                }),
                editable && !isLocked && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResizeHitbox, {
                    onMouseDown: function(e) {
                        return plate.onResizeStart(block, e);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResizeGrabber, {})
                })
            ]
        })
    });
};
var ResizeHitbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a994298d-0"
})(PlateBlock_templateObject());
var ResizeGrabber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a994298d-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.block.border);
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.block.border);
});

;// CONCATENATED MODULE: ./src/components/Plate/Blocks/Blocks.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

var Blocks = function(param) {
    var plate = param.plate;
    plate.observe(function(state) {
        return state.blockIds;
    }); // rerender all blocks when the present blocks change
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: plate.blocks.map(function(block) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateBlock, {
                plate: plate,
                block: block
            }, block.snapshot.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Plate/Blocks/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

;// CONCATENATED MODULE: ./src/components/Plate/Canvas/Canvas.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function Canvas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-image: radial-gradient(circle, ",
        " 1px, #00000000 1px);\n        "
    ]);
    Canvas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Canvas_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-position: -",
        "px -",
        "px;\n      background-size: ",
        " ",
        ";\n      ",
        "\n    "
    ]);
    Canvas_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  ",
        "\n  @media print {\n    background-image: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Canvas = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var plate = param.plate, children = param.children;
    var _$ref;
    var height = plate.observe(function(state) {
        return state.height;
    });
    var width = plate.observe(function(state) {
        return state.width;
    }) + constants/* GRID_WIDTH_EXTRA_PADDING */.gy;
    var editable = plate.observe(function(state) {
        return state.editable;
    });
    (0,react.useEffect)(function() {
        var _$ref;
        if ((_$ref = ref) === null || _$ref === void 0 ? void 0 : _$ref.current) {
            plate.mouseTracker.onCanvasMounts(ref);
        }
    }, [
        (_$ref = ref) === null || _$ref === void 0 ? void 0 : _$ref.current
    ]);
    var handleMouseDown = function(e) {
        var _$ref;
        if (!editable) return;
        if (e.button !== 0) return;
        // check to see if the mouse click happened on the current ref
        if (e.target !== ((_$ref = ref) === null || _$ref === void 0 ? void 0 : _$ref.current)) return;
        plate.onMouseDownCanvas(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenu/* ContextMenu */.x, {
        plate: plate,
        editable: editable,
        block: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCanvas, {
            ref: ref,
            id: constants/* VIENNA_CANVAS_ID */.t1,
            width: width,
            height: height,
            onMouseDown: function(e) {
                return handleMouseDown(e);
            },
            showGrid: editable,
            children: children
        })
    });
});
var StyledCanvas = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c678861-0"
})(_templateObject2(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var showGrid = param.showGrid;
    return showGrid && (0,styled_components_browser_esm/* css */.iv)(Canvas_templateObject1(), constants/* GRID_BACKGROUND_OFFSET */.rJ, constants/* GRID_BACKGROUND_OFFSET */.rJ, "".concat(constants/* GRID_SIZE */.k, "px"), "".concat(constants/* GRID_SIZE */.k, "px"), function(param) {
        var theme = param.theme;
        return (0,styled_components_browser_esm/* css */.iv)(Canvas_templateObject(), theme.canvas.grid);
    });
});

// EXTERNAL MODULE: ./src/classes/plate/Session/index.ts
var Session = __webpack_require__(70822);
// EXTERNAL MODULE: ./src/classes/plate/Session/session.types.ts
var session_types = __webpack_require__(84672);
// EXTERNAL MODULE: ./src/classes/utilities/StyleConstants.ts
var StyleConstants = __webpack_require__(47219);
;// CONCATENATED MODULE: ./src/components/Plate/Canvas/DragRect.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function DragRect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    DragRect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function DragRect(param) {
    var session = param.session;
    var mode = session.observe(function(state) {
        return state.mode;
    });
    var anchorY = session.observe(function(state) {
        return state.anchor.y;
    }); // must observe individually to trigger rerender (objects have reference equality)
    var anchorX = session.observe(function(state) {
        return state.anchor.x;
    });
    var focusY = session.observe(function(state) {
        return state.focus.y;
    });
    var focusX = session.observe(function(state) {
        return state.focus.x;
    });
    var position = PositionUtils/* PositionUtils.getCSSPositionFromPoints */.S.getCSSPositionFromPoints({
        x: anchorX,
        y: anchorY
    }, {
        x: focusX,
        y: focusY
    });
    var top = position.top, left = position.left, height = position.height, width = position.width;
    var bigEnough = height >= StyleConstants/* StyleConstants.minBlockHeight */.P.minBlockHeight && width >= StyleConstants/* StyleConstants.minBlockWidth */.P.minBlockWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDragRect, {
        style: {
            top: top,
            left: left,
            height: height,
            width: width
        },
        mode: mode,
        bigEnough: bigEnough
    });
}
var StyledDragRect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0bea01-0"
})(DragRect_templateObject(), dist.Layer.WIN_LAYER, function(param) {
    var mode = param.mode, theme = param.theme, bigEnough = param.bigEnough;
    if (mode === session_types/* DragMode.Multiselect */.q.Multiselect) {
        return theme.canvas.select;
    }
    return bigEnough ? theme.canvas.create : theme.canvas.dragProhibited;
});

;// CONCATENATED MODULE: ./src/components/Plate/Canvas/DragListener.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function DragListener(param) {
    var plate = param.plate;
    var isCurrentSession = plate.sessionManager.observe(function(state) {
        return state.isCurrentSession;
    });
    return isCurrentSession && plate.sessionManager.currentSession.snapshot.type === Session/* SessionType.DragCanvas */.FF.DragCanvas ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DragRect, {
        session: plate.sessionManager.currentSession
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(20690);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 167 modules
var motion = __webpack_require__(79281);
;// CONCATENATED MODULE: ./src/components/Plate/Data/styles.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: IBM Plex Mono;\n  color: ",
        ";\n  font-size: 10px;\n  margin-bottom: 5px;\n  @media print {\n    display: none;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3dabc53-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
});

;// CONCATENATED MODULE: ./src/components/Plate/Data/Dimensions.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 





function DimensionsWrapper(param) {
    var session = param.session;
    var isVisible = !!session && session.snapshot.type === session_types/* SessionType.DragCanvas */.F.DragCanvas;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            exit: {
                opacity: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dimensions, {
                session: session
            })
        })
    });
}
function Dimensions(param) {
    var session = param.session;
    var anchorY = session.observe(function(state) {
        return state.anchor.y;
    }); // must observe individually to trigger rerender (objects have reference equality)
    var anchorX = session.observe(function(state) {
        return state.anchor.x;
    });
    var focusY = session.observe(function(state) {
        return state.focus.y;
    });
    var focusX = session.observe(function(state) {
        return state.focus.x;
    });
    var ref = PositionUtils/* PositionUtils.getCSSPositionFromPoints */.S.getCSSPositionFromPoints({
        x: anchorX,
        y: anchorY
    }, {
        x: focusX,
        y: focusY
    }), width = ref.width, height = ref.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledData, {
        children: "".concat(PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(width), " x ").concat(PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(height))
    });
}

;// CONCATENATED MODULE: ./src/components/Plate/Data/MousePosition.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function MousePosition(param) {
    var mouseTracker = param.mouseTracker;
    var x = mouseTracker.observe(function(state) {
        return state.position.x;
    });
    var y = mouseTracker.observe(function(state) {
        return state.position.y;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledData, {
        children: "[".concat(PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(x), ", ").concat(PositionUtils/* PositionUtils.snapToGrid */.S.snapToGrid(y), "]")
    });
}

;// CONCATENATED MODULE: ./src/components/Plate/Data/Internals.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function Internals_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 10px;\n  left: 25px;\n  display: flex;\n  flex-direction: column;\n  z-index: ",
        ";\n"
    ]);
    Internals_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function Internals(param) {
    var plate = param.plate;
    plate.sessionManager.observe(function(state) {
        return state.isCurrentSession;
    }); // need to observe for state updates
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInternals, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DimensionsWrapper, {
                session: plate.sessionManager.currentSession
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MousePosition, {
                mouseTracker: plate.mouseTracker
            })
        ]
    });
}
var StyledInternals = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57fabd3c-0"
})(Internals_templateObject(), dist.Layer.WIN_LAYER);

;// CONCATENATED MODULE: ./src/components/Plate/Data/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/UI/Buttons/XButton.tsx
var XButton = __webpack_require__(55894);
// EXTERNAL MODULE: ./src/lib/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(80521);
;// CONCATENATED MODULE: ./src/components/Plate/HelpMenu/ShortcutsMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function ShortcutsMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  color: #aaaaaa;\n  width: calc(100% - 40px);\n  aspect-ratio: 1.618;\n  margin: 20px;\n  border: 1px solid #aaaaaa;\n"
    ]);
    ShortcutsMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcutsMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 64px;\n  right: 55px;\n  width: 375px;\n  top: ",
        ';\n  max-height: 745px;\n  backdrop-filter: blur(10px);\n  user-select: none;\n  font-family: "Inter";\n  background: ',
        ";\n  border: ",
        ";\n  color: ",
        ";\n  overflow-y: scroll;\n"
    ]);
    ShortcutsMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcutsMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px;\n  font-size: 20px;\n  font-weight: 600;\n"
    ]);
    ShortcutsMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px;\n  bottom: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 5px 0px;\n  border-bottom: 1px solid #888888;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  color: ",
        ";\n  transition: all 200ms;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var SHORTCUTS = [
    {
        category: "General Shortcuts",
        shortcuts: constants/* GENERAL_SHORTCUTS */.Fd
    },
    {
        category: "Block Shortcuts",
        shortcuts: constants/* BLOCK_SHORTCUTS */.vi
    }, 
];
var ShortcutsMenu = function(param) {
    var fixedTop = param.fixedTop, close = param.close;
    var shortcutsMenu = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), shorten = ref[0], setShorten = ref[1];
    var ref1 = (0,react.useState)(null), selected = ref1[0], setSelected = ref1[1];
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        if (shortcutsMenu.current.getBoundingClientRect().top < fixedTop) setShorten(true);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcutsMenuWrapper, {
        ref: shortcutsMenu,
        fixedTop: fixedTop,
        shorten: shorten,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                children: [
                    "Keyboard Shortcuts",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(XButton/* XButton */.R, {
                        onClick: close
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcutGIFWrapper, {
                children: (selected === null || selected === void 0 ? void 0 : selected.imageUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: selected.imageUrl,
                    style: {
                        height: "100%",
                        width: "100%"
                    },
                    alt: "shortcut gif"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    style: {
                        padding: 10,
                        textAlign: "center"
                    },
                    children: selected === null ? "hover over command to see use example" : selected.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemWrapper, {
                children: SHORTCUTS.map(function(section) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: section.category
                            }),
                            section.shortcuts.map(function(shortcut) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                    onMouseEnter: function() {
                                        return setSelected(shortcut);
                                    },
                                    onMouseLeave: function() {
                                        return setSelected(null);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: shortcut.command
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: shortcut.label
                                        })
                                    ]
                                }, shortcut.label);
                            })
                        ]
                    }, section.category);
                })
            })
        ]
    });
};
var ShortcutGIFWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87d7a895-0"
})(ShortcutsMenu_templateObject());
var ShortcutsMenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87d7a895-1"
})(ShortcutsMenu_templateObject1(), function(param) {
    var fixedTop = param.fixedTop, shorten = param.shorten;
    return shorten ? "".concat(fixedTop, "px") : "none";
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.blurMenu.background);
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.blurMenu.border);
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.blurMenu.text);
});
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87d7a895-2"
})(ShortcutsMenu_templateObject2());
var ItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87d7a895-3"
})(_templateObject3());
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87d7a895-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87d7a895-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
}, function(param) {
    var theme = param.theme;
    return theme.text.default;
});

;// CONCATENATED MODULE: ./src/components/Plate/HelpMenu/HelpMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function HelpMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  bottom: 20px;\n  right: 40px;\n  z-index: ",
        ";\n  @media print {\n    display: none;\n  }\n"
    ]);
    HelpMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HelpMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 40px;\n  border: ",
        ";\n  color: ",
        ";\n  border-radius: 20px;\n  background: ",
        ';\n  font-size: 30px;\n  font-family: "IBM Plex Mono";\n  font-weight: 300;\n  cursor: pointer;\n  opacity: ',
        ";\n  transition: opacity 0.3s ease;\n  user-select: none;\n  &:hover {\n    opacity: 1;\n  }\n"
    ]);
    HelpMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var HelpMenu = function() {
    var helpMenuRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), menuVisible = ref[0], setMenuVisible = ref[1];
    var ref1 = (0,react.useState)(false), shortcutsVisible = ref1[0], setShortcutsVisible = ref1[1];
    var ref2 = (0,react.useState)(0), fixedTop = ref2[0], setFixedTop = ref2[1];
    var close = function() {
        setMenuVisible(false);
        setShortcutsVisible(false);
    };
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        var ref;
        setFixedTop(((ref = helpMenuRef.current) === null || ref === void 0 ? void 0 : ref.parentElement).getBoundingClientRect().top);
    });
    (0,esm/* useOnClickOutside */.t$)(helpMenuRef, close);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HelpWrapper, {
        ref: helpMenuRef,
        id: "karls-specialty-menu",
        children: [
            shortcutsVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcutsMenu, {
                fixedTop: fixedTop,
                close: close
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpButtonWrapper, {
                visible: menuVisible || shortcutsVisible,
                onClick: function() {
                    setShortcutsVisible(!shortcutsVisible);
                },
                children: "?"
            })
        ]
    });
};
var HelpWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17d261d5-0"
})(HelpMenu_templateObject(), dist.Layer.WIN_LAYER);
var HelpButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17d261d5-1"
})(HelpMenu_templateObject1(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
}, function(param) {
    var theme = param.theme;
    return theme.primary;
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var visible = param.visible;
    return visible ? 1 : 0.2;
});

// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 103 modules
var react_markdown = __webpack_require__(91261);
// EXTERNAL MODULE: ./src/app/themes.ts
var themes = __webpack_require__(33568);
;// CONCATENATED MODULE: ./src/components/Plate/Generation/Messages.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function Messages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 50px;\n"
    ]);
    Messages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Messages_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  margin: 20px 0;\n  padding: 20px;\n"
    ]);
    Messages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Messages_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  padding: 10px 0;\n"
    ]);
    Messages_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Messages_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Messages_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





function Messages(param) {
    var messages = param.messages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessagesWrapper, {
        children: messages.map(function(message, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageRole, {
                        children: message.role
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                            children: message.text
                        })
                    })
                ]
            }, index);
        })
    });
}
var MessagesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77ec129-0"
})(Messages_templateObject());
var MessageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77ec129-1"
})(Messages_templateObject1(), themes/* Color.Gray3 */.Il.Gray3, themes/* Color.Gray1 */.Il.Gray1);
var MessageRole = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77ec129-2"
})(Messages_templateObject2());
var MessageContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77ec129-3"
})(Messages_templateObject3());

// EXTERNAL MODULE: ./src/app/useCurrentUser.ts
var useCurrentUser = __webpack_require__(29635);
// EXTERNAL MODULE: ./src/components/AppTopbar/CurrentUserAvatar.tsx
var CurrentUserAvatar = __webpack_require__(28242);
// EXTERNAL MODULE: ./src/components/AppTopbar/NavButtons.tsx
var NavButtons = __webpack_require__(78361);
// EXTERNAL MODULE: ./src/components/AppTopbar/styles.ts
var AppTopbar_styles = __webpack_require__(7609);
// EXTERNAL MODULE: ./src/components/AppTopbar/UserDropdown.tsx + 10 modules
var UserDropdown = __webpack_require__(31170);
// EXTERNAL MODULE: ./src/lib/logging/datadog.ts
var datadog = __webpack_require__(73392);
;// CONCATENATED MODULE: ./src/components/Plate/EditorAvatars/EditorAvatars.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function EditorAvatars_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n  user-select: none;\n"
    ]);
    EditorAvatars_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var EditorAvatars = function(param) {
    var plate = param.plate;
    datadog/* clientLogger.log */.u.log("".concat(plate));
    // const presentUsers = plate.socket.observe((state) => state.presentUsers);
    //@critical
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarsWrapper, {});
};
var AvatarsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93d0b542-0"
})(EditorAvatars_templateObject());

;// CONCATENATED MODULE: ./src/components/Plate/EditorAvatars/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Shared/User/Username.tsx + 2 modules
var Username = __webpack_require__(67272);
// EXTERNAL MODULE: ./src/components/DrilledView/SidePanel/Sections/Attributes.tsx + 3 modules
var Attributes = __webpack_require__(82236);
// EXTERNAL MODULE: ./src/components/UI/Alert/Alert.tsx
var Alert = __webpack_require__(18638);
// EXTERNAL MODULE: ./src/components/UI/Buttons/ButtonPrimitives.tsx
var ButtonPrimitives = __webpack_require__(70854);
// EXTERNAL MODULE: ./src/components/UI/Modal/style.ts
var style = __webpack_require__(92405);
;// CONCATENATED MODULE: ./src/components/Plate/Settings/PlateSettings.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PlateSettings_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    PlateSettings_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlateSettings_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: red;\n  padding: 10px 0px;\n"
    ]);
    PlateSettings_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PlateSettings_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0.5;\n  background-color: #e6e6e6;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n"
    ]);
    PlateSettings_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PlateSettings_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 20px 5px 20px;\n  width: ",
        ";\n  font-weight: 400;\n  margin-bottom: 10px;\n  display: flex;\n"
    ]);
    PlateSettings_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PlateSettings_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-collapse: collapse;\n  font-weight: 400;\n  font-size: 13px;\n"
    ]);
    PlateSettings_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










function PlateSettings(param) {
    var setModalOpen = param.setModalOpen, plate = param.plate;
    var ref;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var ref1 = (0,react.useState)(false), deleteAlertOpen = ref1[0], setDeleteAlertOpen = ref1[1];
    var ref2 = (0,react.useState)(false), cleanupAlertOpen = ref2[0], setCleanupAlertOpen = ref2[1];
    var currentUserIsOwner = plate.snapshot.currentUserIsOwner;
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    var title = plate.observe(function(state) {
        return state.title;
    });
    var handleClose = function() {
        setModalOpen(false);
    };
    var handleDelete = function() {
        if (currentUserIsOwner) {
            currentUser === null || currentUser === void 0 ? void 0 : currentUser.deletePlate(plate);
        }
    };
    var onDeleteAccept = function() {
        handleDelete();
        setDeleteAlertOpen(false);
    };
    var onCleanupAccept = function() {
        plate.cleanupBlocks();
        handleClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        close: handleClose,
        title: "Plate Settings",
        children: [
            !currentUserIsOwner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisabledBox, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningText, {
                        children: "Only the owner of the Plate can update settings."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTable, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<title>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<owner>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Username/* Username */.R, {
                                                user: plate.owner
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<visibility>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: isPublic ? "Public" : "Private"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<plateId>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: plate.snapshot.id
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<createdAt>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: plate.snapshot.createdAt.toString()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<updatedAt>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: plate.snapshot.updatedAt.toString()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<screenshotTime>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: (ref = plate.snapshot.screenshotTime) === null || ref === void 0 ? void 0 : ref.toString()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<blockCount>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: plate.blockCount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            isFirstColumn: true,
                                            children: "<likes>"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes.TD, {
                                            children: plate.snapshot.likes.length
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style.H2, {
                        style: {
                            marginTop: "20px"
                        },
                        children: "Block Actions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageEditButton, {
                        onClick: function() {
                            return setCleanupAlertOpen(true);
                        },
                        half: true,
                        $disabled: !plate.blockCount,
                        children: "Clean Up"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                        type: "question",
                        acceptText: "Continue",
                        declineText: "Cancel",
                        onAccept: onCleanupAccept,
                        onDecline: function() {
                            return setCleanupAlertOpen(false);
                        },
                        isOpen: cleanupAlertOpen,
                        headerText: "Clean up blocks?",
                        bodyText: "WARNING: this will change the order and arrangement of blocks."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style.H2, {
                        children: "Plate Actions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageEditButton, {
                        onClick: function() {
                            return setDeleteAlertOpen(true);
                        },
                        $dangerous: true,
                        half: true,
                        children: "Delete"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                        type: "question",
                        acceptText: "Delete",
                        declineText: "Cancel",
                        onAccept: onDeleteAccept,
                        onDecline: function() {
                            return setDeleteAlertOpen(false);
                        },
                        isOpen: deleteAlertOpen,
                        headerText: "Are you sure you want to delete this plate?",
                        bodyText: "Deleting is a permanent action and cannot be undone."
                    })
                ]
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15ec8fcb-0"
})(PlateSettings_templateObject());
var WarningText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15ec8fcb-1"
})(PlateSettings_templateObject1());
var DisabledBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15ec8fcb-2"
})(PlateSettings_templateObject2());
var PageEditButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonPrimitives/* Button */.zx).withConfig({
    componentId: "sc-15ec8fcb-3"
})(PlateSettings_templateObject3(), function(param) {
    var half = param.half;
    return half ? "50%" : "100%";
});
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-15ec8fcb-4"
})(PlateSettings_templateObject4());

;// CONCATENATED MODULE: ./src/components/Plate/Settings/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/UI/Tooltip/index.ts + 60 modules
var Tooltip = __webpack_require__(23732);
// EXTERNAL MODULE: ../../node_modules/algoliasearch/dist/algoliasearch.umd.js
var algoliasearch_umd = __webpack_require__(30241);
var algoliasearch_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_umd);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 5 modules
var InstantSearch = __webpack_require__(34267);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(18214);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/connectors/connectStateResults.js
var connectStateResults = __webpack_require__(41024);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/connectors/connectHits.js
var connectHits = __webpack_require__(88232);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(1175);
// EXTERNAL MODULE: ./src/classes/api/index.ts + 5 modules
var api = __webpack_require__(54411);
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(28459);
// EXTERNAL MODULE: ./src/components/UI/Form/index.ts + 1 modules
var Form = __webpack_require__(49641);
;// CONCATENATED MODULE: ./src/components/Plate/ShareMenu/lib/styles.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function lib_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  background: ",
        ';\n  padding: 8px;\n  font-family: "IBM Plex Mono", monospace;\n  font-size: 13px;\n  height: 30px;\n  text-overflow: ellipsis;\n'
    ]);
    lib_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ShareInput = (0,styled_components_browser_esm/* default */.ZP)(Form/* StandardInput */.r).withConfig({
    componentId: "sc-c9e3b9dd-0"
})(lib_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.subtleContrast;
});

;// CONCATENATED MODULE: ./src/components/Plate/ShareMenu/SharablePageLink.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function SharablePageLink_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  cursor: pointer;\n  font-weight: 400;\n  font-size: 12px;\n"
    ]);
    SharablePageLink_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function SharablePageLink(param) {
    var link = param.link, copyLink = param.copyLink;
    var handleCopy = function() {
        copyLink();
        react_toastify_esm/* toast.success */.Am.success("Link Copied", constants/* TOAST_DEFAULT_ARGS */.tS);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareActions, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareInput, {
                onChange: function() {},
                value: link,
                style: {
                    marginRight: "10px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimitives/* Button */.zx, {
                onClick: handleCopy,
                children: "copy"
            })
        ]
    });
}
var ShareActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7335125-0"
})(SharablePageLink_templateObject());

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(26235);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Plate/Topbar/lib/styles.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function Topbar_lib_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 5px;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  :hover {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    Topbar_lib_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  :hover {\n    filter: brightness(0.8);\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var PTButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d7f37ef-0"
})(Topbar_lib_styles_templateObject(), function(props) {
    return props.theme.text.subtle;
});
var StyledLockButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d7f37ef-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme, isPublic = param.isPublic;
    return isPublic ? theme.block.border : theme.accent;
});

// EXTERNAL MODULE: ./src/components/UI/Links/index.ts
var Links = __webpack_require__(47209);
;// CONCATENATED MODULE: ./src/components/Plate/Topbar/lib/Buttons.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 








/* ------------------------- Buttons ---------------------- */ var Lock = function(param) {
    var plate = param.plate, styles = param.styles;
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
        tooltipText: isPublic ? "Plate is public. Click to change." : "Plate is private. Click to change.",
        delayShow: 1000,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLockButton, {
            isPublic: isPublic,
            onClick: function() {
                return plate.changePrivacy();
            },
            id: "cy-lock-button",
            style: styles,
            children: isPublic ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Unlocked */.dT, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Locked */.QM, {})
        })
    });
};
/* ------------------------- Sign In / Ownername ---------------------- */ var Ownername = function(param) {
    var ownername = param.ownername;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            whiteSpace: "nowrap"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/user/".concat(ownername),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* UnderlineOnlyLinkStyle */.I7, {
                    children: ownername
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    userSelect: "none"
                },
                children: "\xa0/\xa0"
            })
        ]
    });
};
var SignIn = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/signin",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* UnstyledLink */.Ho, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarTextButton, {
                children: "SIGN_IN"
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Shared/User/Avatar.tsx
var Avatar = __webpack_require__(57646);
;// CONCATENATED MODULE: ./src/components/Plate/ShareMenu/SharedUser.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function SharedUser_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "Inter";\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 0 12px 0;\n  font-weight: 300;\n  user-select: none;\n'
    ]);
    SharedUser_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SharedUser_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    SharedUser_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SharedUser_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 6px;\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n  height: 40px;\n"
    ]);
    SharedUser_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SharedUser_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n"
    ]);
    SharedUser_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SharedUser_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: ",
        ";\n  color: ",
        ";\n  font-size: 13px;\n  text-decoration: ",
        ";\n  transition: all 0.1s;\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    SharedUser_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var SharedUser = function(param) {
    var user = param.user, addable = param.addable, plate = param.plate;
    var userIsOwner = plate.owner.snapshot.id === user.snapshot.id;
    var handleRemove = function() {
        if (!userIsOwner) {
            plate.removeEditor(user);
        }
    };
    var handleAdd = function() {
        plate.addEditor(user);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUser, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserDisplay, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: user.inAppLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* StyledLink */.Fg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                src: user.avatarURL(42),
                                size: 42
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Name, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                passHref: true,
                                href: "/user/".concat(user.snapshot.username),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* StyledLink */.Fg, {
                                    href: "/user/".concat(user.snapshot.username),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayName, {
                                        children: user.snapshot.displayName
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Username/* Username */.R, {
                                user: user
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Role, {
                owner: userIsOwner,
                onClick: addable ? handleAdd : handleRemove,
                children: !addable ? userIsOwner ? "Owner" : "Remove" : "Make Editor"
            })
        ]
    });
};
var StyledUser = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-805716ac-0"
})(SharedUser_templateObject());
var UserDisplay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-805716ac-1"
})(SharedUser_templateObject1());
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-805716ac-2"
})(SharedUser_templateObject2());
var DisplayName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-805716ac-3"
})(SharedUser_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var Role = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-805716ac-4"
})(SharedUser_templateObject4(), function(param) {
    var owner = param.owner;
    return owner ? "default" : "pointer";
}, function(param) {
    var theme = param.theme;
    return theme.text.subtle;
}, function(param) {
    var owner = param.owner;
    return owner ? "none" : "underline";
}, function(param) {
    var owner = param.owner, theme = param.theme;
    return owner ? theme.text.subtle : theme.text.default;
});

;// CONCATENATED MODULE: ./src/components/Plate/ShareMenu/ShareMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function ShareMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: ",
        "px;\n  top: 45px;\n  right: 30px;\n  border: ",
        ";\n  background-color: ",
        ';\n  font-family: "IBM Plex Mono";\n  z-index: ',
        ";\n  color: ",
        ";\n"
    ]);
    ShareMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShareMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 12px 12px 0 12px;\n  border-bottom: ",
        ";\n  transition: max-height 0.1s;\n"
    ]);
    ShareMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShareMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 15px 0 15px;\n  border-bottom: ",
        ";\n"
    ]);
    ShareMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShareMenu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 5px;\n  font-size: 13px;\n  font-weight: 400;\n"
    ]);
    ShareMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var SHARE_MENU_WIDTH = 330;
var ShareMenu = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var close = param.close, plate = param.plate;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var currentUserIsOwner = plate.observe(function(state) {
        return state.currentUserIsOwner;
    });
    plate.observe(function(state) {
        return state.editorIds;
    });
    var editors = plate.editors;
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    var searchClient = algoliasearch_umd_default()("T4XM1HXWPD", (currentUser === null || currentUser === void 0 ? void 0 : currentUser.snapshot.algoliaApiKey) || "");
    var _$ref = (0,react.useState)([]), allUsersLol = _$ref[0], setAllUsersLol = _$ref[1];
    (0,react.useEffect)(function() {
        if (!currentUserIsOwner) return;
        // @todo this needs to be algolia...
        api/* API.users.getAll */.b.users.getAll().then(function(users) {
            setAllUsersLol(users);
        });
    }, []);
    // close if you click outside of the menu or button
    (0,esm/* useOnClickOutside */.t$)(ref, close);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMenu, {
        children: [
            currentUserIsOwner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                        indexName: "".concat(config/* ALGOLIA_INDEX_NAME */.l, "_items"),
                        searchClient: searchClient,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSearchWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSearchBox, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareUsersWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSearchResults, {
                                    allUsers: allUsersLol,
                                    plate: plate
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareUsersWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedUser, {
                                addable: false,
                                user: plate.owner,
                                plate: plate
                            }),
                            editors.map(function(user) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedUser, {
                                    addable: false,
                                    user: user,
                                    plate: plate
                                }, user.snapshot.id);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareUsersWrapper, {
                        style: {
                            paddingBottom: "12px",
                            userSelect: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock, {
                                plate: plate,
                                styles: {
                                    position: "relative",
                                    top: "2px",
                                    left: "-3px",
                                    marginRight: "2px"
                                }
                            }),
                            isPublic ? "PUBLIC" : "PRIVATE",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtext, {
                                children: isPublic ? "Anyone can view this Plate" : editors.length ? "Only *you and collaborators* can view this Plate" : "Only *you* can view this Plate"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SharablePageLink, {
                link: plate.externalLink,
                copyLink: plate.copyLink
            })
        ]
    });
});
var StyledMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce711203-0"
})(ShareMenu_templateObject(), SHARE_MENU_WIDTH, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, dist.Layer.WIN_LAYER, function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var ShareSearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce711203-1"
})(ShareMenu_templateObject1(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
});
var ShareUsersWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce711203-2"
})(ShareMenu_templateObject2(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
});
var Subtext = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce711203-3"
})(ShareMenu_templateObject3());
/* -------------------------------------------------- */ /*                    Search Comps                    */ /* -------------------------------------------------- */ var ShareSearchBox = (0,connectSearchBox/* default */.Z)(function(param) {
    var currentRefinement = param.currentRefinement, refine = param.refine;
    var handleChange = function(event) {
        refine(event.currentTarget.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareInput, {
        placeholder: "Add collaborators...",
        autoFocus: true,
        style: {
            height: "36px"
        },
        value: currentRefinement,
        onChange: handleChange
    });
});
var ShareSearchResults = (0,connectStateResults/* default */.Z)(function(param) {
    var searchState = param.searchState, allUsers = param.allUsers, plate = param.plate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: searchState && searchState.query && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHits, {
            allUsers: allUsers,
            plate: plate
        })
    });
});
var CustomHits = (0,connectHits/* default */.Z)(function(param) {
    var hits = param.hits, allUsers = param.allUsers, plate = param.plate;
    var hitsThatAreUsers = hits.filter(function(hit) {
        return hit.recordType === "user";
    });
    var usersThatAreHits = allUsers.filter(function(user) {
        return hitsThatAreUsers.find(function(hit) {
            return hit.username === user.snapshot.username;
        });
    });
    var currentEditorIds = plate.observe(function(state) {
        return state.editorIds;
    });
    var withCurrentEditorsRemoved = usersThatAreHits.filter(function(user) {
        return !currentEditorIds.includes(user.snapshot.id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            withCurrentEditorsRemoved.slice(0, 9).map(function(user) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedUser, {
                    user: user,
                    addable: true,
                    plate: plate
                }, user.snapshot.id);
            }),
            withCurrentEditorsRemoved.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    paddingBottom: "12px"
                },
                children: "No matching users found..."
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/Plate/ShareMenu/ShareButton.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function ShareButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"
    ]);
    ShareButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShareButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  user-select: none;\n  -webkit-user-select: none;\n  cursor: pointer;\n  margin-right: 15px;\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    ShareButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ShareButton = function(param) {
    var plate = param.plate;
    var buttonRef = (0,react.useRef)(null);
    var editors = plate.editors;
    var editable = plate.observe(function(state) {
        return state.editable;
    });
    var ref = (0,react.useState)(false), menuOpen = ref[0], setMenuOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareButtonContainer, {
        ref: buttonRef,
        children: [
            editable && editors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                tooltipText: "".concat(editors[0].snapshot.username, " ").concat(editors.length > 1 ? "and ".concat(editors.length - 1, " other").concat(editors.length - 1 > 1 ? "s" : "", " ") : "", " can edit"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Shared */.jH, {
                    style: {
                        marginRight: "10px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarTextButton, {
                onClick: function() {
                    return setMenuOpen(!menuOpen);
                },
                id: "cy-share-button",
                children: "SHARE"
            }),
            menuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareMenu, {
                plate: plate,
                close: function() {
                    return setMenuOpen(false);
                },
                ref: buttonRef
            })
        ]
    });
};
var ShareButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28f0f8d5-0"
})(ShareButton_templateObject());
var TopbarTextButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28f0f8d5-1"
})(ShareButton_templateObject1());

;// CONCATENATED MODULE: ./src/components/Plate/Settings/SettingsButton.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



var SettingsButton = function(param) {
    var plate = param.plate;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarTextButton, {
                onClick: function() {
                    return setOpen(true);
                },
                children: "SETTINGS"
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateSettings, {
                setModalOpen: setOpen,
                plate: plate
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49839);
// EXTERNAL MODULE: ./src/classes/utilities/FileUtils.ts + 15 modules
var FileUtils = __webpack_require__(56920);
;// CONCATENATED MODULE: ./src/components/Plate/Status/SyncStatusAlertInfo.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function SyncStatusAlertInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 15px;\n  margin-bottom: 10px;\n"
    ]);
    SyncStatusAlertInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function SyncStatusAlertInfo(param) {
    var plate = param.plate;
    var isConnected = plate.socket.observe(function(state) {
        return state.connected;
    });
    var awaitingReceipts = plate.socket.observe(function(state) {
        return state.awaitingReceipt;
    });
    var awaitingSend = plate.socket.observe(function(state) {
        return state.awaitingSend;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSyncStatusInfo, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Connected: ",
                    isConnected ? "true" : "false, retrying..."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Changes in transit: ",
                    awaitingReceipts.length,
                    awaitingReceipts.length ? ", size: ".concat(FileUtils/* FileUtils.getReadableFileSizeFromBytes */.P.getReadableFileSizeFromBytes(awaitingReceipts.reduce(function(acc, cur) {
                        return acc + cur.size;
                    }, 0))) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "About to send: ",
                    awaitingSend
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Total unsaved: ",
                    awaitingSend + awaitingReceipts.length
                ]
            })
        ]
    });
}
var StyledSyncStatusInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f00e8701-0"
})(SyncStatusAlertInfo_templateObject());

// EXTERNAL MODULE: ./src/lib/logging/segment.ts
var segment = __webpack_require__(56372);
// EXTERNAL MODULE: ./src/store/modules/globalUI.ts
var globalUI = __webpack_require__(78697);
;// CONCATENATED MODULE: ./src/components/Plate/Status/SyncStatusIcon.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function SyncStatusIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 12px;\n  height: 12px;\n  /* Accent/Smalt Blue */\n  background-color: #4d9090;\n  margin-right: 14px;\n  transition: background-color 75ms ease-in;\n"
    ]);
    SyncStatusIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













function SyncStatusIcon(param) {
    var plate = param.plate;
    var _Math;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isConnected = plate.socket.observe(function(state) {
        return state.connected;
    });
    var awaitingReceipts = plate.socket.observe(function(state) {
        return state.awaitingReceipt;
    });
    var awaitingSend = plate.socket.observe(function(state) {
        return state.awaitingSend;
    });
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    // state
    var ref = (0,react.useState)(Date.now()), currentTime = ref[0], setCurrentTime = ref[1];
    var ref1 = (0,react.useState)(false), activeNoSave = ref1[0], setActiveNoSave = ref1[1]; // there are unsaved transactions that should've gotten a receipt
    var ref2 = (0,react.useState)(false), saveErrorAlertOpen = ref2[0], setSaveErrorAlertOpen = ref2[1];
    // calculated
    var sendsWithoutReceipts = awaitingReceipts.length;
    var totalUnsaved = sendsWithoutReceipts + (awaitingSend || 0);
    var beenWhile = awaitingReceipts.length && currentTime - (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(awaitingReceipts.map(function(param) {
        var time = param.time, size = param.size;
        return Math.min(+time, +time - size * 0.0005);
    }) // give big updates a little more time
    )) > dist.ONE_SECOND * 10;
    (0,esm/* useInterval */.Yz)(function() {
        setCurrentTime(Date.now());
    }, dist.ONE_SECOND / 2);
    (0,react.useEffect)(function() {
        if (!isConnected && awaitingReceipts.length) {
            datadog/* clientLogger.warn */.u.warn("User ".concat(currentUser.snapshot.username, " needs to reconnect to socket"), {
                userId: currentUser.snapshot.id,
                area: "socket"
            });
        } else if (saveErrorAlertOpen && !beenWhile) {
            setActiveNoSave(false);
            datadog/* clientLogger.info */.u.info("No save mode recovered for user ".concat(currentUser.snapshot.username), {
                area: "socket"
            });
        }
    }, [
        isConnected,
        awaitingReceipts.length
    ]);
    if (beenWhile && !saveErrorAlertOpen) {
        datadog/* clientLogger.error */.u.error("User ".concat(currentUser.snapshot.username, " entered no save mode"), {
            userId: currentUser.snapshot.id,
            isConnected: isConnected,
            area: "socket"
        });
        (0,segment/* safeSegmentTrack */.ed)({
            event: "No Save Mode Entered"
        });
        dispatch(globalUI/* globalUIActions.enteredNoSaveMode */.yD.enteredNoSaveMode()); // to track in logrocket
        setActiveNoSave(true);
        setSaveErrorAlertOpen(true);
    }
    var handleSaveErrorAccept = function() {
        setSaveErrorAlertOpen(false);
    };
    var closeSaveErrorAlert = function() {
        setSaveErrorAlertOpen(false);
        window.location.reload();
    };
    // constants for the state of no save mode
    var noSaveRecovered = !activeNoSave && !beenWhile && saveErrorAlertOpen; // true when no save mode was entered (alert is open) and is now recovered
    var noSaveConnectionLost = !noSaveRecovered && !isConnected && saveErrorAlertOpen; // true when no save mode was entered (alert is open) because the connection was lost
    // text for the no save error alert
    var headerText = noSaveRecovered ? "Connection to the server was reestablished." : noSaveConnectionLost ? "Connection lost." : "Changes are out of sync with the server.";
    var bodyText = noSaveRecovered ? "Changes were saved, you can go back to editing." : noSaveConnectionLost ? "You can reload or wait for the connection to be reestablished. Warning: reloading may result in data loss." : "You can reload or wait for the changes to sync. Warning: reloading may result in data loss.";
    var SpecificStatus = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Websocket: ",
                    (isConnected === null || isConnected === void 0 ? void 0 : isConnected.toString()) || "false"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "About to send: ",
                    awaitingSend
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Changes in transit: ",
                    sendsWithoutReceipts
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip/* Tooltip */.u, {
        tooltipText: SpecificStatus,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncStatusIconStyled, {
                style: {
                    backgroundColor: beenWhile ? "#db4112" : totalUnsaved === 0 ? "#4D9090" : "#F2E294"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                type: noSaveRecovered ? "notification" : "question",
                // on accept and on decline used in "question" type (when unrecovered)
                acceptText: "Wait",
                onAccept: handleSaveErrorAccept,
                declineText: "Reload",
                onDecline: closeSaveErrorAlert,
                declineDangerous: true,
                // on okay used in "notification" type (if/when recovered)
                okayText: "Okay",
                onOkay: closeSaveErrorAlert,
                isOpen: saveErrorAlertOpen,
                headerText: headerText,
                bodyText: bodyText,
                children: !noSaveRecovered && /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncStatusAlertInfo, {
                    plate: plate
                })
            })
        ]
    });
}
var SyncStatusIconStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d01f2c91-0"
})(SyncStatusIcon_templateObject());

;// CONCATENATED MODULE: ./src/components/Plate/Topbar/Circle.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function Circle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  background-color: ",
        ";\n  /* color: ",
        '; */\n  font-weight: 500;\n  font-size: 12px;\n  font-family: "IBM Plex Mono";\n  transition: all 150ms ease;\n  /* fade in 2px black boarder on hover */\n  &:hover {\n    box-shadow: 0 0 0 0.7px ',
        ";\n  }\n  /* grow on hover */\n  &:hover {\n    transform: scale(1.1);\n  }\n  /* grow on click */\n  &:active {\n    transform: scale(1.2);\n  }\n"
    ]);
    Circle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Circle_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  margin-right: 10px;\n  position: relative;\n  top: 1px;\n"
    ]);
    Circle_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

// a Circle that grows on hover, opens a dropdown on click
var Circle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1880b70b-0"
})(Circle_templateObject(), function(param) {
    var theme = param.theme;
    return theme.primary;
}, function(param) {
    var theme = param.theme;
    return theme.primary;
}, function(param) {
    var theme = param.theme;
    return theme.primary;
});
var CircleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1880b70b-1"
})(Circle_templateObject1());

;// CONCATENATED MODULE: ./src/components/Shared/ContentEditable/lib/utils.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ var selectAll = function(element) {
    var range = document.createRange();
    range.selectNodeContents(element);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
};
var clearSelection = function() {
    if (window.getSelection) {
        var ref, ref1;
        if ((ref = window.getSelection()) === null || ref === void 0 ? void 0 : ref.empty) {
            var // Chrome
            ref2;
            (ref2 = window.getSelection()) === null || ref2 === void 0 ? void 0 : ref2.empty();
        } else if ((ref1 = window.getSelection()) === null || ref1 === void 0 ? void 0 : ref1.removeAllRanges) {
            var // Firefox
            ref3;
            (ref3 = window.getSelection()) === null || ref3 === void 0 ? void 0 : ref3.removeAllRanges();
        }
    }
};

;// CONCATENATED MODULE: ./src/components/Shared/ContentEditable/ContentEditable.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


var ContentEditable = function(param) {
    var value = param.value, onChange = param.onChange, editable = param.editable, onBlur = param.onBlur, onKeyDownOverride = param.onKeyDownOverride, autoFocus = param.autoFocus, className = param.className;
    var ref = react.useRef(null);
    var defaultOnKeyDown = function(e) {
        e.stopPropagation();
        switch(e.key){
            case "Enter":
                var ref1;
                e.preventDefault();
                (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.blur();
                break;
            default:
                break;
        }
    };
    (0,react.useEffect)(function() {
        if (autoFocus && ref.current) {
            selectAll(ref.current);
        }
    }, [
        ref.current
    ]);
    var handleBlur = function(e) {
        clearSelection();
        onBlur(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: className,
        ref: ref,
        spellCheck: false,
        suppressContentEditableWarning: true,
        contentEditable: editable,
        onInput: function(e) {
            return onChange(e.currentTarget.textContent || "");
        },
        onKeyDown: onKeyDownOverride || defaultOnKeyDown,
        onBlur: handleBlur,
        children: value
    });
};

;// CONCATENATED MODULE: ./src/components/Plate/Topbar/lib/PlateTitle.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PlateTitle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  margin-right: 5px;\n  outline: none;\n  border: 1px solid transparent;\n  padding: 3px;\n  color: ",
        ";\n  cursor: ",
        ";\n  &:focus {\n    border: ",
        ";\n  }\n"
    ]);
    PlateTitle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlateTitle_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n  flex-shrink: 0;\n  margin-right: 5px;\n  margin-left: 60px;\n  outline: none;\n  border: 1px solid transparent;\n  padding: 3px;\n  cursor: default;\n"
    ]);
    PlateTitle_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function PlateTitle(param) {
    var plate = param.plate;
    var title = plate.observe(function(state) {
        return state.title;
    });
    var ref = (0,react.useState)(title), titleValue = ref[0], setTitleValue = ref[1];
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    var currentUserIsOwner = plate.snapshot.currentUserIsOwner;
    var justCreated = new Date(plate.snapshot.createdAt).getTime() > Date.now() - 2000;
    (0,react.useEffect)(function() {
        // for when the plate title changes outside of the plate title component
        setTitleValue(title);
    }, [
        title
    ]);
    var handleBlur = function() {
        if (titleValue && titleValue !== title) {
            plate.changeTitle(titleValue);
        }
    };
    var onKeyDown = function(e) {
        // handle the meta+a key combination while maintaining the default Enter key behavior
        switch(e.key){
            case hotkeys/* KeyCodes.A */.mW.A:
                if (e.metaKey) {
                    e.stopPropagation();
                    // select all the text in the title
                    var selection = window.getSelection();
                    if (selection) {
                        var range = document.createRange();
                        range.selectNodeContents(e.target);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                }
                break;
            case hotkeys/* KeyCodes.ENTER */.mW.ENTER:
                e.preventDefault();
                if (e.target) {
                    e.target.blur();
                }
                break;
            // allow arrow keys to move the cursor
            case hotkeys/* KeyCodes.ARROW_LEFT */.mW.ARROW_LEFT:
            case hotkeys/* KeyCodes.ARROW_RIGHT */.mW.ARROW_RIGHT:
            case hotkeys/* KeyCodes.ARROW_UP */.mW.ARROW_UP:
            case hotkeys/* KeyCodes.ARROW_DOWN */.mW.ARROW_DOWN:
                e.stopPropagation();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
        editable: currentUserIsOwner,
        value: title,
        onChange: setTitleValue,
        autoFocus: currentUserIsOwner && justCreated,
        onBlur: handleBlur,
        isPublic: isPublic,
        isOwner: currentUserIsOwner,
        onKeyDownOverride: onKeyDown
    });
}
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(ContentEditable).withConfig({
    componentId: "sc-8d3718ee-0"
})(PlateTitle_templateObject(), function(param) {
    var theme = param.theme, isPublic = param.isPublic;
    return isPublic ? "inherit" : theme.accent;
}, function(param) {
    var isOwner = param.isOwner;
    return isOwner ? "text" : "default";
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
});
var ReadOnlyTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8d3718ee-1"
})(PlateTitle_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});

// EXTERNAL MODULE: ./src/components/UI/Buttons/IconButtons/Connect/index.ts + 1 modules
var Connect = __webpack_require__(57459);
// EXTERNAL MODULE: ./src/components/UI/Buttons/IconButtons/Like/index.ts + 1 modules
var Like = __webpack_require__(69397);
;// CONCATENATED MODULE: ./src/components/Plate/Topbar/PlateTopbar.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PlateTopbar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    PlateTopbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var PlateTopbar = function(param) {
    var plate = param.plate;
    var ref;
    var isLiked = plate.observe(function(state) {
        return state.isLiked;
    });
    var currentUserIsOwner = plate.snapshot.currentUserIsOwner;
    var editable = plate.observe(function(state) {
        return state.editable;
    });
    var messages = (ref = plate.generator) === null || ref === void 0 ? void 0 : ref.observe(function(state) {
        return state.messages;
    });
    var avatarRef = (0,react.useRef)(null);
    var viewsRef = (0,react.useRef)(null);
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var ref1 = (0,react.useState)(false), userDropdownOpen = ref1[0], setUserDropdownOpen = ref1[1];
    var ref2 = (0,react.useState)(false), viewsDropdownOpen = ref2[0], setViewsDropdownOpen = ref2[1];
    var ref3 = (0,react.useState)(false), connectMenuOpen = ref3[0], setConnectMenuOpen = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPlateTopbar, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppTopbar_styles/* StyledTopbarLeft */.Tj, {
                children: [
                    currentUser && lib/* isElectron */.d && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavButtons/* NavButtons */._, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                                ref: viewsRef,
                                onClick: function() {
                                    return setViewsDropdownOpen(!viewsDropdownOpen);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDropdown/* ViewsDropdown */.g, {
                                rendered: viewsDropdownOpen,
                                closeDropdown: function() {
                                    return setViewsDropdownOpen(false);
                                },
                                viewsRef: viewsRef
                            })
                        ]
                    }),
                    currentUserIsOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock, {
                        plate: plate
                    }),
                    !currentUserIsOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Ownername, {
                        ownername: plate.snapshot.owner.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateTitle, {
                        plate: plate
                    }),
                    currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Like/* Like */.m, {
                        isLiked: isLiked,
                        like: plate.like
                    }),
                    currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Connect/* Connect */.l, {
                        plate: plate,
                        block: null,
                        menuOpen: connectMenuOpen,
                        setMenuOpen: setConnectMenuOpen
                    }),
                    !!(messages === null || messages === void 0 ? void 0 : messages.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return plate.showModal({
                                title: "Messages",
                                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Messages, {
                                    messages: messages
                                })
                            });
                        },
                        style: {
                            marginLeft: "10px"
                        },
                        children: "Messages"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppTopbar_styles/* StyledTopbarRight */.Tu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorAvatars, {
                        plate: plate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton, {
                        plate: plate
                    }),
                    editable && !lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsButton, {
                                plate: plate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncStatusIcon, {
                                plate: plate
                            })
                        ]
                    }),
                    !currentUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentUserAvatar/* CurrentUserAvatar */.z, {
                        ref: avatarRef,
                        handleClick: function() {
                            return setUserDropdownOpen(!userDropdownOpen);
                        },
                        styles: {
                            marginLeft: "15px"
                        }
                    })
                ]
            }),
            currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDropdown/* UserDropdown */.w, {
                rendered: userDropdownOpen,
                closeDropdown: function() {
                    return setUserDropdownOpen(false);
                },
                avatarRef: avatarRef
            })
        ]
    });
};
var StyledPlateTopbar = (0,styled_components_browser_esm/* default */.ZP)(AppTopbar_styles/* StyledAppTobar */.PE).withConfig({
    componentId: "sc-992db64e-0"
})(PlateTopbar_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(5170);
// EXTERNAL MODULE: ../../node_modules/@react-hook/window-size/dist/module/index.js + 2 modules
var dist_module = __webpack_require__(29605);
// EXTERNAL MODULE: ../../node_modules/react-zoom-pan-pinch/dist/index.esm.js
var index_esm = __webpack_require__(95519);
;// CONCATENATED MODULE: ./src/components/Plate/ZoomWrapper/ZoomWrapper.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 





function ZoomWrapper(param) {
    var children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dist_module/* useWindowSize */.iP)(), 1), windowWidth = ref[0];
    var scale = windowWidth / dist.DEFAULT_PAGE_WIDTH;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformWrapper */.d$, {
        initialScale: scale,
        disabled: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
            wrapperStyle: {
                width: "100vw"
            },
            children: children
        })
    });
}

// EXTERNAL MODULE: ./src/components/UI/Buttons/index.ts
var Buttons = __webpack_require__(75640);
// EXTERNAL MODULE: ./src/components/UI/ConditionalWrapper/index.ts
var ConditionalWrapper = __webpack_require__(93234);
;// CONCATENATED MODULE: ./src/components/UI/Cursors/CursorSVG.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
// SVG cursor shape
function CursorSvg(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "44",
        viewBox: "0 0 24 36",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: color,
            d: "M5.65376 12.3673H5.46026L5.31717 12.4976L0.500002 16.8829L0.500002 1.19841L11.7841 12.3673H5.65376Z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/UI/Cursors/Cursors.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 




// Spring animated cursor
function Cursors(param) {
    var plate = param.plate;
    var cursors = plate.socket.observe(function(state) {
        return state.mice;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!cursors.length && cursors.map(function(cursor) {
            var _mousePosition = cursor.mousePosition, x = _mousePosition.x, y = _mousePosition.y;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                style: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    zIndex: dist.Layer.WIN_LAYER
                },
                initial: {
                    x: x,
                    y: y
                },
                animate: {
                    x: x,
                    y: y
                },
                transition: {
                    type: "spring",
                    damping: 30,
                    mass: 0.8,
                    stiffness: 350
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CursorSvg, {
                    color: (0,color/* stringToHSL */.J)(cursor.username, {})
                })
            }, cursor.username);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/UI/Cursors/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14129);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(66420);
// EXTERNAL MODULE: ../../node_modules/react-dropzone/dist/es/index.js + 4 modules
var dist_es = __webpack_require__(62135);
;// CONCATENATED MODULE: ./src/components/Uploader/Uploader.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function Uploader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  :focus {\n    outline: none;\n  }\n"
    ]);
    Uploader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function Uploader(param) {
    var plate = param.plate, children = param.children;
    var dropAreaRef = (0,react.useRef)();
    var onDropRejected = function(rejectedFiles) {
        var oversize = rejectedFiles.filter(function(fileRejection) {
            return fileRejection.file.size > 500000000;
        });
        var errors = rejectedFiles.map(function(fileRejection) {
            return fileRejection.errors.map(function(error) {
                return error.message;
            });
        });
        var nonOversizeRejections = errors.filter(function(errorMessage) {
            return !errorMessage.includes("file-too-large");
        });
        if (oversize.length) {
            react_toastify_esm/* toast.error */.Am.error("Max file size is 500MB", constants/* TOAST_DEFAULT_ARGS */.tS);
        } else if (nonOversizeRejections.length) {
            react_toastify_esm/* toast.error */.Am.error("File not supported", constants/* TOAST_DEFAULT_ARGS */.tS);
        }
    };
    var ref = (0,dist_es/* useDropzone */.uI)({
        multiple: true,
        accept: constants/* ACCEPTED_FILE_TYPES */._0,
        noClick: true,
        maxSize: 500000000,
        onDropAccepted: plate.onDrop,
        onDropRejected: onDropRejected
    }), getRootProps = ref.getRootProps, getInputProps = ref.getInputProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropArea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps()), {
        ref: dropAreaRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getInputProps()), {
                type: "file",
                name: "file",
                id: "plate_upload_input"
            })),
            children
        ]
    }));
}
var StyledDropArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-57aab08a-0"
})(Uploader_templateObject());

;// CONCATENATED MODULE: ./src/lib/hooks/useMouseEvent.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
// Hook to add a mouseevent listener of a given type
function useMouseEvent(type, handler) {
    (0,react.useEffect)(function() {
        var listener = function(event) {
            handler(event);
        };
        document.addEventListener(type, listener);
        return function() {
            document.removeEventListener(type, listener);
        };
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        handler
    ]);
}

// EXTERNAL MODULE: ./src/lib/hooks/useHotkey.ts
var useHotkey = __webpack_require__(51367);
;// CONCATENATED MODULE: ./src/lib/hooks/usePlateShortcuts.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function usePlateShortcuts(plate) {
    // Undo Redo
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.UNDO */.LM.UNDO, function() {
        return plate.onUndo();
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.REDO */.LM.REDO, function() {
        return plate.onRedo();
    });
    // Selection
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.COMMAND_A */.LM.COMMAND_A, function() {
        return plate.selectAll();
    }, [], {
        stopPropagation: true,
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.ESCAPE */.LM.ESCAPE, function() {
        return plate.deselectAll();
    });
    // Arrow Keys
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.ARROW_DOWN */.LM.ARROW_DOWN, function() {
        return plate.onArrowKey("down");
    }, [], {
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.SHIFT_ARROW_DOWN */.LM.SHIFT_ARROW_DOWN, function() {
        return plate.onArrowKey("down");
    }, [], {
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.ARROW_UP */.LM.ARROW_UP, function() {
        return plate.onArrowKey("up");
    }, [], {
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.SHIFT_ARROW_UP */.LM.SHIFT_ARROW_UP, function() {
        return plate.onArrowKey("up");
    }, [], {
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.ARROW_LEFT */.LM.ARROW_LEFT, function() {
        return plate.onArrowKey("left");
    }, [], {
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.SHIFT_ARROW_LEFT */.LM.SHIFT_ARROW_LEFT, function() {
        return plate.onArrowKey("left");
    }, [], {
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.ARROW_RIGHT */.LM.ARROW_RIGHT, function() {
        return plate.onArrowKey("right");
    }, [], {
        preventDefault: true
    });
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.SHIFT_ARROW_RIGHT */.LM.SHIFT_ARROW_RIGHT, function() {
        return plate.onArrowKey("right");
    }, [], {
        preventDefault: true
    });
    //Delete
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.BACKSPACE */.LM.BACKSPACE, function() {
        return plate.onBackspace();
    });
}

;// CONCATENATED MODULE: ./src/lib/hooks/useScroll.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
// Hook
function useScroll(handler) {
    (0,react.useEffect)(function() {
        // function to call on event
        var listener = function() {
            handler();
        };
        // Add event listener
        window.addEventListener("scroll", listener, true);
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener("scroll", listener, true);
        };
    }, []);
}

// EXTERNAL MODULE: ./src/lib/hooks/useWindowResize.ts
var useWindowResize = __webpack_require__(58289);
;// CONCATENATED MODULE: ./src/components/Plate/PlateView.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PlateView_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative; // important\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 100px;\n  user-select: none;\n  padding: ",
        "px;\n  z-index: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @media screen and (max-width: ",
        ") {\n    padding-left: 0;\n    padding-right: 0;\n  }\n"
    ]);
    PlateView_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PlateView_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  overflow-y: scroll;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    PlateView_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PlateView_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: none;\n  @media print {\n    width: 100%;\n    display: block;\n    font-family: "IBM Plex Mono", monospace;\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 20px;\n    text-align: left;\n  }\n'
    ]);
    PlateView_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




























function PlateView(param) {
    var plate = param.plate;
    var editable = plate.observe(function(state) {
        return state.editable;
    });
    var title = plate.observe(function(state) {
        return state.title;
    });
    var modal = plate.observe(function(state) {
        return state.modal;
    });
    var router = (0,next_router.useRouter)();
    var _query = router.query, drilledBlockId = _query.blockId, drilledPageId = _query.pageId;
    var scrollRef = (0,react.useRef)(null);
    var canvasRef = (0,react.useRef)(null);
    var isScreenshotter = (0,es/* useSelector */.v9)(function(state) {
        return state.globalUI.uiSettings.isScreenshotter;
    });
    (0,react.useEffect)(function() {
        return function() {
            plate.destroy();
        };
    }, []);
    usePlateShortcuts(plate);
    useMouseEvent("mousemove", function(e) {
        return plate.onMouseMove(e);
    });
    useMouseEvent("mouseup", function() {
        return plate.onMouseUp();
    });
    useScroll(function() {
        return plate.mouseTracker.onScroll(canvasRef);
    });
    (0,useWindowResize/* useWindowResize */.w)(function() {
        return plate.mouseTracker.onResizeWindow(canvasRef);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        title,
                        " by @",
                        plate.snapshot.owner.username
                    ]
                })
            }),
            !isScreenshotter && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateTopbar, {
                plate: plate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                condition: lib/* isMobile */.tq,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomWrapper, {
                        children: children
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* ScrollContainer */.l$, {
                    ref: scrollRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverflowAligner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                            onMouseDown: function(e) {
                                return plate.onMouseDown(e);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintOnlyTitle, {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                                    condition: editable && !lib/* isMobile */.tq,
                                    wrapper: function(children) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Uploader, {
                                            plate: plate,
                                            children: children
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Canvas, {
                                        plate: plate,
                                        ref: canvasRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks, {
                                                plate: plate
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DragListener, {
                                                plate: plate
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cursors, {
                                                plate: plate,
                                                color: "red"
                                            })
                                        ]
                                    })
                                }),
                                editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* StandardButton */.K3, {
                                    onClick: function() {
                                        return plate.extend();
                                    },
                                    styles: {
                                        width: "200px",
                                        marginTop: "30px"
                                    },
                                    className: "hide-on-print",
                                    children: "Extend Plate"
                                })
                            ]
                        })
                    })
                })
            }),
            modal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                title: modal.title,
                close: function() {
                    return plate.closeModal();
                },
                children: modal.body
            }),
            editable && !lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)(Internals, {
                plate: plate
            }),
            editable && !lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpMenu, {}),
            (drilledBlockId || drilledPageId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DrilledView/* DrilledView */.p, {})
        ]
    });
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e45f44c4-0"
})(PlateView_templateObject(), constants/* PLATE_PADDING */.tI, dist.Layer.ROOT, globalStyles/* DEVICE.small */.T.small);
/**
 * Aligns plate left if viewport is narrower than the plate. All Properties are
 * required.
 */ var OverflowAligner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e45f44c4-1"
})(PlateView_templateObject1());
var PrintOnlyTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e45f44c4-2"
})(PlateView_templateObject2());

// EXTERNAL MODULE: ./src/lib/types.ts
var types = __webpack_require__(45085);
;// CONCATENATED MODULE: ./src/components/Plate/PlateFetcher.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 





function PlateFetcher(param) {
    var username = param.username, pageSlug = param.pageSlug;
    var ref = (0,react.useState)(null), plate = ref[0], setPlate = ref[1];
    var ref1 = (0,react.useState)(types/* LoadingStatus.Idle */.Q.Idle), loadingStatus = ref1[0], setLoadingStatus = ref1[1];
    (0,react.useEffect)(function() {
        // due to some ssr bullshit or something these don't exist on first render
        if (!(pageSlug && username)) return;
        setLoadingStatus(types/* LoadingStatus.Loading */.Q.Loading);
        Plate/* Plate.load */.h.load(username, pageSlug).then(function(fetchedPlate) {
            setPlate(fetchedPlate);
            setLoadingStatus(types/* LoadingStatus.Succeeded */.Q.Succeeded);
        }).catch(function() {
            setLoadingStatus(types/* LoadingStatus.Failed */.Q.Failed);
        });
    }, [
        pageSlug,
        username
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper/* LoadingWrapper */.u, {
        status: loadingStatus,
        loadingType: LoadingWrapper/* LoadingType.Hidden */.F.Hidden,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateView, {
            plate: plate
        }, pageSlug)
    });
}

;// CONCATENATED MODULE: ./src/pages/plate/[username]/[pageSlug].tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


var PageController = function() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, username = _query.username, pageSlug = _query.pageSlug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateFetcher, {
        username: username,
        pageSlug: pageSlug
    });
};
/* harmony default export */ var _pageSlug_ = (PageController);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6253,7599,9281,7649,2135,2954,8745,2539,733,9774,2888,179], function() { return __webpack_exec__(35169); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);